import React, { Component } from 'react';

import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../styles/AppTheme';

export class Maintenance extends Component {
  render() {
    return (
      <div className={css(AppStyles.container)}>
        <div className={css(Styles.imgContainer)}>
          <img
            src={require('../assets/images/logo.png')}
            className={css(Styles.imgContent)}
          />
        </div>
        <p className={css(Styles.nfMiddle)}>System is under maintenance</p>
        <p className={css(Styles.l2)}>We will be back soon with a revamped experience :)</p>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  imgContainer: {
    paddingTop: 100,
    maxWidth: 100,
    '@media (max-width: 767px)': {
      minWidth: 'unset',
      width: 100,
    }
  },
  imgContent: {
    width: '100%',
    height: '100%',
  },
  nfMiddle: {
    margin: 10,
    fontSize: 20,
    paddingTop: 20,
    textAlign: 'center'
  },
  l2: {
    margin: 10,
    fontSize: 16,
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/screens/Maintenance.js